import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsFlatWeaving = React.forwardRef(
  (props: SvgIconProps, ref: any) => {
    return (
      <SvgIcon {...props} ref={ref}>
        <g fill="currentColor">
          <path
            d="M7.4375052,15.2500134h10.0000134v-2.8125038H7.4375052V15.2500134z M8.2708302,13.2708349h8.3333378v1.2500029H8.2708302
		V13.2708349z"
          />
          <path
            d="M7.4375052,23.5833492h10.0000134V20.875021H7.4375052V23.5833492z M8.2708302,21.6041718h8.3333378v1.1458263H8.2708302
		V21.6041718z"
          />
          <path
            d="M19.625021,15.8750124v-1.7708273h-1.8750019v1.7708282H7.0208292v-1.7708282H5.2500014v1.7708282H3.5833249v7.7083359
		h3.4375043v-5.6250095h10.8333406v5.6250095h3.4375057v-7.7083368H19.625021z M18.5833435,14.9375114h0.2083263v0.9375019
		h-0.2083263V14.9375114z M5.9791756,14.9375114h0.2083263v0.9375019H5.9791756V14.9375114z M20.4583721,22.7500248
		l-0.0000248-0.0000019h-1.7708282v-5.6250076H6.1875019v5.6250095H4.4166751v-6.1458359h16.0416965V22.7500248z"
          />
          <path
            d="M17.4375172,18.3750172H7.4375038v1.9791794h10.0000134V18.3750172z M16.6041908,19.5208435H8.270854v-0.3125h8.3333368
		V19.5208435z"
          />
          <path
            d="M18.2708435,6.2916508V2.2291443h-0.7291756V0.4583178h-1.8750029v1.7708266H8.9999819V0.4583178H7.1249781v1.7708266
		H6.3958025v4.0625067h11.8750162H18.2708435z M16.5000172,1.291644h0.2083263v0.9375004h-0.2083263V1.291644z M7.9583297,1.291644
		h0.2083249v0.9375004H7.9583297V1.291644z M17.4375172,5.458323v0.0000014H7.229178V2.9583204h10.2083397V5.458323z"
          />
          <rect
            x="11.9166842"
            y="7.0208268"
            width="0.8333263"
            height="5.0000067"
          />
          <polygon points="14.3125124,7.0208268 13.4791861,7.0208268 14.0000124,12.020833 14.8333387,12.020833 	" />
          <polygon points="15.7708406,7.0208268 15.0416651,7.0208268 15.979167,12.020833 16.8124924,12.020833 	" />
          <polygon points="10.458334,7.0208268 9.9375076,12.020833 10.770834,12.020833 11.2916603,7.0208268 	" />
          <polygon points="8.8958321,7.0208268 7.9583297,12.020833 8.7916565,12.020833 9.7291584,7.0208268 	" />
        </g>
      </SvgIcon>
    );
  }
);

export default AppIconsFlatWeaving;
